var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import useFieldApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-field-api";
import React from "react";
import { useTranslation } from "react-i18next";
import { SWITCH } from "../../../classConstants";
import { getClassName } from "../../../helpers";
import { RadioGroup } from "../RadioGroup/RadioGroup";
var switchFactory = function () {
    var Switch = function (props) {
        var _a, _b;
        var t = useTranslation().t;
        var onToggle = props.onToggle, name = props.name, radioGroupProps = __rest(props, ["onToggle", "name"]);
        var defaultChecked = ((_a = props.input) === null || _a === void 0 ? void 0 : _a.value) === "true";
        var defaultUnchecked = ((_b = props.input) === null || _b === void 0 ? void 0 : _b.value) === "false";
        var options = [
            { "value": "true", label: t("switchable.yes"), checked: defaultChecked },
            { "value": "false", label: t("switchable.no"), checked: defaultUnchecked },
        ];
        return React.createElement(RadioGroup, __assign({ isInline: true, name: name }, radioGroupProps, { className: getClassName(props.className, SWITCH), options: options }));
    };
    return Switch;
};
export var Switch = switchFactory();
export var ReactiveSwitch = function (props) {
    var className = props.className, name = props.name;
    return React.createElement(Switch, __assign({ name: name, className: className }, useFieldApi(props)));
};
